import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';
import Logo from '../assets/logo.png';
import CloseIcon from '../assets/x.svg'; // Import Close Icon

function Header() {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className={`header ${isVisible ? 'visible' : 'hidden'}`}>
      <div className="header-container">
        {/* Logo */}
        {/* Logo */}
        <div className="header-logo">
          <Link to="/">
            <img src={Logo} alt="Logo" />
          </Link>
        </div>

        {/* Hamburger Button (with Close Icon replacing bars when open) */}
        <div className="hamburger-container" onClick={toggleMenu}>
          {menuOpen ? (
            <img src={CloseIcon} alt="Close" className="close-icon" />
          ) : (
            <div className="hamburger">
              <span className="bar"></span>
              <span className="bar"></span>
              <span className="bar"></span>
            </div>
          )}
        </div>

        {/* Navigation Menu */}
        <nav className={`header-nav ${menuOpen ? 'open' : ''}`}>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/programs">Programs</Link></li>
            <li><Link to="/periodization">Periodization</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/drops">Drops</Link></li>
            <li><Link to="/equipment">Equipment</Link></li>
            <li className="mobile-nav-link"><Link to="/signin">Sign In</Link></li>
            <li className="mobile-nav-link"><Link to="/app">Download App</Link></li>
          </ul>
        </nav>
        <div className="header-buttons">
          <Link to="/signin"><div className="c-ripple header-button header-button-login">
            Sign In
          </div></Link>
          <Link to="/app"><div className="c-ripple header-button header-button-primary">
            Download App
          </div></Link>
        </div>
      </div>
    </header>
  );
}

export default Header;